import ConfigResolver from '../../config/ConfigResolver';
import Http from '../../shared/Http/Http';
import _ from 'lodash';

import { CognitoUserPool} from "amazon-cognito-identity-js";
import { sessionExpireLogout } from './userActions';
const { IdentityPoolId, ClientId, UserPoolId, region} = ConfigResolver.config();


const refreshAccessToken = (options,dispatch) => {
  return new Promise((resolve, reject) => {
    const poolData = { ClientId, UserPoolId };
    var userPool = new CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    cognitoUser.getSession((err, session) => {
      if (err) {
        sessionExpireLogout(dispatch);
        localStorage.removeItem('userToken');
        reject(err);
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
};
export function getSegmentation(data){
  return async (dispatch, currentState) => {
    dispatch({
        type: "GET_SEGMENTATION_PENDING",
    });
    data.provider = 'ipg';
    const url = '/toolkit/get';
    let token = await refreshAccessToken(currentState().options,dispatch);
    Http.post(url, data, currentState, false, token)
    .then((response) => {
      dispatch({
        type: 'GET_SEGMENTATION_FULFILLED',
        data: response.data
      });
    })
    .catch((error) => {
      console.log(error);
      dispatch({
          type: 'GET_SEGMENTATION_REJECTED',
          error: error
      });
    });
  }
}

export function getImportantBenefits(data){
    return async (dispatch, currentState) => {
      dispatch({
          type: "GET_IMORTANT_BENEFITS_PENDING",
      });
      data.provider = 'ipg';
      const url = '/benefit/importants';
      let token = await refreshAccessToken(currentState().options,dispatch);
      Http.post(url, data, currentState, false, token)
      .then((response) => {
        dispatch({
          type: 'GET_IMORTANT_BENEFITS_FULFILLED',
          data: response.data
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
            type: 'GET_IMORTANT_BENEFITS_REJECTED',
            error: error
        });
      });
    }
}
export function addSegmentation(data){
  return async (dispatch, currentState) => {
    dispatch({ type: 'EDIT_SEGMENTATION_PENDING' });
    data.provider = 'ipg';
    const url = '/toolkit/create';
    let token = await refreshAccessToken(currentState().options,dispatch);
    Http.post(url, data, currentState, false, token)
      .then(response => {
        dispatch({ type: "EDIT_SEGMENTATION_FULFILLED", data: response.data });
      })
      .catch((error) => {
          console.log(error);
          dispatch({ type: 'EDIT_SEGMENTATION_REJECT', error });
      });
  };
}
export function editSegmentation(data){
  return async (dispatch, currentState) => {
    dispatch({ type: 'EDIT_SEGMENTATION_PENDING' });
    data.provider = 'ipg';
    const url = '/toolkit/edit';
    let token = await refreshAccessToken(currentState().options,dispatch);
    Http.put(url, data, currentState, false, token)
      .then(response => {
        dispatch({ type: "EDIT_SEGMENTATION_FULFILLED", data: response.data });
      })
      .catch((error) => {
          console.log(error);
          dispatch({ type: 'EDIT_SEGMENTATION_REJECT', error });
      });
  };
}

export function resetImportants() {
  return dispatch => { dispatch({ type: "RESET_IMPORTANTS" }) };
}



// WEBPACK FOOTER //
// ./src/store/actions/segmentationActions.js